import React from 'react';
import { Icon, IconName } from '@hills-design-system/components';

export interface CmsButtonLinkProps {
  text: string;
  url: string;
  external?: boolean;
  button_type?: string;
  icon?: string;
  icon_position?: string;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
}

export const CmsButtonLink: React.FC<CmsButtonLinkProps> = ({
  text,
  url,
  external,
  button_type,
  icon,
  icon_position = 'pre',
  className,
  style,
  children,
}) => {
  const isDownload = icon === 'download' || button_type === 'Download';

  const downloadIcon = <Icon icon={IconName.Download} size={20} className="shrink-0" />;

  const defaultContent = isDownload ? (
    <>
      {icon_position === 'pre' && downloadIcon}
      {text}
      {icon_position !== 'pre' && downloadIcon}
    </>
  ) : (
    text
  );

  const content = children ?? defaultContent;

  if (isDownload) {
    const handleDownload = (e: React.MouseEvent<HTMLAnchorElement>) => {
      if (!url) return;

      try {
        const linkUrl = new URL(url, window.location.origin);
        const isCrossOrigin = linkUrl.origin !== window.location.origin;

        if (isCrossOrigin) {
          e.preventDefault();
          fetch(url)
            .then((res) => res.blob())
            .then((blob) => {
              const blobUrl = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = blobUrl;
              a.download = url.split('/').pop()?.split('?')[0] || 'download';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(blobUrl);
            });
        }
      } catch {
        // For invalid URLs, fall through to default browser behavior
      }
    };

    return (
      <a
        href={url || undefined}
        download
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${text} (downloads file)`}
        className={className}
        style={style}
        onClick={handleDownload}
      >
        {content}
      </a>
    );
  }

  if (external) {
    return (
      <a
        href={url || undefined}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        style={style}
      >
        {content}
      </a>
    );
  }

  return (
    <a href={url || undefined} className={className} style={style}>
      {content}
    </a>
  );
};

export default CmsButtonLink;
